export default class News {
    constructor() {
        this.newslist = window.btrNews || {};
        this.revisit = false;
        this.init();
    }

    init() {
        this.setNews();
        this.changeNews();
        this.newsToggle();
    }

    getParam() {
        let param = location.search.slice(1).split('&'),
            output = {};

        // 取得したパラメータをプロパティ・値に分けて格納
        for (let i = 0; param[i]; i++) {
            let j = param[i].split('=');
            output[j[0]] = j[1];
        }

        return output;
    }

    setNews(newsIndex = 0) {
        if (this.newslist.articles.length === 0) {
            return;
        }

        const news_body = document.querySelector('.js-news__body');
        const news_date = document.querySelector('.js-news__date');
        const news_category = document.querySelector('.js-news__category');
        const news_ttl = document.querySelector('.js-news__ttl');

        // URLパラメータがある場合
        if (!this.revisit && this.getParam().id) {
            const param = this.getParam().id;
            const newsdetail = document.querySelector(`[data-newsid="${param}"]`);

            // newsIndexを上書き
            newsIndex = newsdetail.attributes['data-newsindex'].value;

            // SPでモーダル開く
            const newsmodalbody = document.querySelector('.newsmodal__body');
            newsmodalbody.classList.add('-active');

            // ニュースリストの一番上に
            document.getElementById('js-newslist').scrollTop = newsdetail.offsetTop;

            // フラグ変更
            this.revisit = true;
        }

        news_body.innerHTML = this.newslist.articles[newsIndex].body;
        news_date.innerHTML = this.newslist.articles[newsIndex].pubDate.replace(/\//g, '.');
        news_category.innerHTML = this.newslist.articles[newsIndex].categories;
        news_ttl.innerHTML = this.newslist.articles[newsIndex].title;

        this.activeList(newsIndex);
    }

    activeList(newsIndex = 0) {
        const lists = [...document.querySelectorAll('.js-newsdetail')];

        document.querySelector('.js-newsdetail.-active') && document.querySelector('.js-newsdetail.-active').classList.remove('-active');
        lists[newsIndex].classList.add('-active');

        function resizeNews() {
            const news_scroller = document.getElementById('js-newsscroller');
            const news_scroller_height = news_scroller.clientHeight;
            document.documentElement.style.setProperty('--articleHeight', `${news_scroller_height}px`);
        }

        // 高さ設定
        setTimeout(function () {
            resizeNews();
        }, 200);

        // 高さ設定（もう一回）
        setTimeout(function () {
            resizeNews();
        }, 500);

        // 高さ設定（もう一回）
        setTimeout(function () {
            resizeNews();
        }, 1000);
    }

    changeNews() {
        const newsbtn = [...document.querySelectorAll('.js-newsdetail')];
        const topnewsbtn = [...document.querySelectorAll('.js-topnewsdetail')];

        newsbtn.forEach((el) => {
            el.addEventListener('click', () => {
                const newsIndex = el.getAttribute('data-newsindex') || 0;
                this.setNews(parseInt(newsIndex));
            });
        });

        topnewsbtn.forEach((el) => {
            el.addEventListener('click', () => {
                const newsIndex = el.getAttribute('data-newsindex') || 0;
                this.setNews(parseInt(newsIndex));
            });
        });
    }

    newsToggle() {
        const newsback = document.querySelector('.js-newsback');
        const newsbody = document.querySelector('.newsmodal__body');
        const newsdetail = [...document.querySelectorAll('.js-newsdetail')];
        const listallbtn = [...document.querySelectorAll('.js-newslistall')];
        const tabcontainer = document.querySelector('.js-tabcontainer');

        newsback.addEventListener('click', () => {
            newsbody.classList.remove('-active');
            tabcontainer.classList.remove('-active');
        });

        newsdetail.forEach((el) => {
            el.addEventListener('click', () => {
                newsbody.classList.add('-active');
                tabcontainer.classList.add('-active');
            });
        });

        listallbtn.forEach((el) => {
            el.addEventListener('click', () => {
                newsbody.classList.remove('-active');
                tabcontainer.classList.remove('-active');
            });
        });
    }
}
